<template>
    <Spinner v-if="isLoading" />
    <Toast />
        <ConfirmDialog></ConfirmDialog>
        <ConfirmDialog group="templating">
                <template #message="slotProps">
                    <div class="flex p-4">
                        <i :class="slotProps.message.icon" style="font-size: 1.5rem"></i>
                        <p class="pl-2">{{slotProps.message.message}}</p>
                    </div>
                </template>
        </ConfirmDialog>
        <ConfirmDialog group="positionDialog"></ConfirmDialog>
    <div class="grid">        	    
        <div class="card col-12 mainTitle">
            <h3 class="stationsHeader">{{ translated('userprofile').toUpperCase() }}</h3>            
            <Button
                @click="helpVisible=!helpVisible"
                icon="pi pi-question"
                :label="ponocString"
                class="helpButton p-button-rounded">
            </Button>          
        </div>	
        
        <div class="card col-12 helpSection" v-if="helpVisible">
            <div class="sekcijaOpis">
                Stranica PROFIL namenjena je ažuriranju vaših ličnih podataka, kao i podataka osoba koje su povezane s vama (članovi porodice). Molimo vas da unesete sve podatke pažljivo i da se uverite da su podaci tačni. Informacije poput pola i datuma rođenja su od ključnog značaja za izradu analiza, dok nam ostali traženi podaci pomažu da vas lakše pronađemo u našoj bazi podataka. Ako ste greškom uneli člana porodice i želite da uklonite taj zapis, možete to učiniti klikom na dugme "delete" (crveno dugme).
            </div>

            <div class="sekcijaOpis">
                U slučaju da ste uneli podatke člana porodice, ali ste naknadno uočili da podaci nisu tačni, možete ih ispraviti. Klikom na plavu ikonicu sa olovkom, aplikacija će otvoriti prozor u kojem možete izvršiti potrebne izmene.
            </div>
        </div>


        <Person ref="masterPerson" @saved="masterSaved"></Person>
               
        <div class="col-12 buttons">
            <div class="grid">
                <div class="col-4 col-offset-4">
                    <div class="grid">
                        <div class="submitplaceholder col-5">
                            <Button @click="saveMasterChild" icon="pi pi-check" :label="translated('save')" class="submitsave" ></Button>
                        </div>
                        <div class="col-2"></div>
                        <div class="submitplaceholder col-5">
                            <Button class="submitback"  :label="translated('backtomainscreen')" @click="backToDashboard()"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>        

        <div class="card col-12 subtitleHeader">
            <div class="titleSubPersonPlaceholder">
                <div class="subPersonHeaderPlace"> 
                    <div class="subPersonHeader">{{translated('connectedPersons').toUpperCase()}}</div> 
                </div>                
                <Button class="addNewPerson" :label="translated('add')"  @click="insertNewPersonClick"/>         
            </div>
            
        </div>	

        <div class="profile-view-persons card col-12">
            <div class="grid headerTableSubPerson">
                <div class="col-12 hideOnDesktop">{{ translated('person') }}</div>
                <div class="col-4 hideOnMobile">{{ translated('name') }}</div>
                <div class="col-4 hideOnMobile">{{ translated('birthday') }}</div>
                <div class="col-4 hideOnMobile">{{ translated('email') }}</div>
            </div>
            <div v-for="person in PersonSubPersons" :key="person.id" :myId="person.id" class="p-fluid grid elementGroup elementPersonGroup">                
                <div class="col-12 sm:col-4">                    
                    <div class="personName">{{ (person.name.trim() + ' ' + person.surname.trim()).trim() }}</div>
                </div>
                <div class="col-12 sm:col-4">
                    <div class="hideOnDesktop personJmbgLabel">{{ translated('birthday') }}</div>
                    <!-- <div>{{ person.birthDay.split('-')[2] }}-{{person.birthDay.split('-')[1]}}-{{person.birthDay.split('-')[0] }}</div> -->
                    <div>
                        {{ person.birthDay ? (person.birthDay.split('-')[2] + '-' + person.birthDay.split('-')[1] + '-' + person.birthDay.split('-')[0]) : '/' }}
                    </div>
                </div>
                <div class="col-12 sm:col-4">
                    <div class="hideOnDesktop personEmailLabel">{{ translated('email') }}</div>
                    <div class="personEmail">{{ person.email }}</div>
                    <div class="personControls">                        
                        <Button icon="pi pi-trash" class="p-button-danger removePersonButton" :data-userid=person.id @click="confirm1" />                     
                        <Button icon="pi pi-pencil" class="editPersonButton" :data-userid=person.id @click="editChildUser" />   
                    </div>
                </div>
            </div>
        </div>

        <Dialog class="modal-profile" :header="dialogHeader()" v-model:visible="displayModalUser" modal :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '50vw'}">

            <div class="grid">     
                <Person ref="personModal" @saved="childSaved"></Person>
            </div>

            <template #footer>

                <Button v-if="isNew" :label="translated('copyperson')" severity="secondary" icon="pi pi-check" @click="copyPerson()" class="btnCopy"/>
                <Button :label="translated('save')" icon="pi pi-check" @click="saveChild()" class="btnSave" />
                <Button :label="translated('cancel')" icon="pi pi-times" @click="displayModalUser=false" autofocus class="btnCancel" />
     

                <!-- 
                     class="submitbtn btnCopy"
                    
                    <div v-if="childUserId != 'other'" class="modal-buttons">
                    <Button :label="translated('save')" icon="pi pi-check" @click="saveChild()" class="submitbtn" />
                    <Button :label="translated('cancel')" icon="pi pi-times" @click="displayModalUser=false" autofocus class="submitbtn" />
                </div>
                <div v-else class="modal-buttons">
                    <Button :label="translated('insertPerson')" icon="pi pi-check" @click="saveChild()" class="submitbtn" />
                    <Button :label="translated('goBack')" icon="pi pi-times" @click="displayModalUser=false" autofocus class="submitbtn" />
                </div> -->
            </template>
        </Dialog>
    </div>
    
</template>

<script>
import { email, required, sameAs, between, numeric, minLength, maxLength, requiredUnless, requiredIf, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import createHttp from "@/services/http";
import router from "@/router";
import { computed } from "vue";
import store from "@/store";
import ConfirmDialog from 'primevue/confirmdialog';
import Spinner from "@/components/Spinner.vue"
import Dropdown from 'primevue/dropdown';
import Calendar from 'primevue/calendar';
import Person from '@/components/Person.vue';


const davcna = (value) => (value.match(/^[A-Z]{2}[0-9]{8}$/) == value);

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: { Spinner, ConfirmDialog, Dropdown, Calendar, Person },  
    computed : {
        computedPersonOptions() {
            return this.PersonOptions;
        },
        ponocString() {
            return this.translated('translatedHelp');
        }
    },
    data() {
        return {            
            translated: computed(() => store.getters.getTranslate),
            isLoading: false,
            PersonSubPersons: [],
            displayModalUser: false,
            isNew: false,
            helpVisible: false
        }
    },
   
    async mounted() {
        // this.getPerson();
        this.$refs.masterPerson.Load();
        this.getChildPersons();
    },    
    methods: {
        dialogHeader() {
            if(this.childUserId != 'other'){
                return this.translated('linkedUserPreview');//'PREGLED POVEZANOG KORISNIKA';
            }
            return this.translated('insertNewUser');//'UNESITE NOVOG KORISNIKA';
        },

        async getChildPersons(){
            const http = createHttp(true);
            // console.log('ZOVEM API PERSONWITHCHILDREN************************************************************************************');
            const result2 = await http.get(process.env.VUE_APP_API_FOLDER + "/getPersonWithChildren");
            // console.log(result2)

            debugger;
            if(result2.status == 200){
                this.PersonSubPersons = result2.data;
                this.PersonOptions=[];
                for (let x in result2.data) {
                    this.PersonOptions.push(
                    {label:result2.data[x].name + " " + result2.data[x].surname, value: result2.data[x].id}
                )};
                this.PersonOptions.push({label: this.translated('addPerson'), value: "other"});
            }
        },
        async confirm1(event) {            
            // console.log('confirm1');
            this.userIdForDelete = event.currentTarget.getAttribute("data-userid");
            this.$confirm.require({
                message: this.translated('areYouSureDeletePerson'),
                header: this.translated('canceling'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.translated('yes'),
                rejectLabel: this.translated('no'),
                accept: () => {
                    // console.log('confirm1accept');
                    this.isLoading = true;
                    this.removeChildUser(event);                    
                    this.isLoading = false;                    
                },
                reject: () => {
                    // console.log('confirm1reject');
                    this.isLoading = true;
                    this.$toast.add({severity:'error', summary:this.translated('declined'), detail:this.translated('youDidNotDeletePerson'), life: 3000});
                    this.isLoading = false;
                }
            });
        },
        async removeChildUser(event) {
            // console.log('removeChildUser');
            // console.log(this.userIdForDelete);

            this.isLoading = true;

            const http = createHttp(true); 
            try {                
                const response = await http.delete(process.env.VUE_APP_API_FOLDER + "/deleteChildPerson?id=" + this.userIdForDelete);
                await this.getChildPersons();

            } catch (error) {
                // console.log(error);
                this.isLoading = false;
            }

        },        
        backToDashboard(){
            router.push("/");
        },
        
        insertNewPersonClick() {
            this.isNew = true;
            this.displayModalUser=true;

            this.$nextTick(() => {
                this.$refs.personModal.Clear();
                this.$refs.personModal.UnlockAll();
            }); 

        },
        editChildUser(event) {
            debugger;

            this.isNew = false;
            this.displayModalUser=true;
            
            const userId = event.currentTarget.getAttribute("data-userid");

            // Sedaj kontroli za popup za userja rečem, da se prvo resetira potem pa ji rečem, da se naloži
            this.$nextTick(() => {
                this.$refs.personModal.Clear();
                this.$refs.personModal.Load(userId);
            });                 
            
        },

        saveMasterChild() {
            this.$refs.masterPerson.Save();
        },
        masterSaved(){
            debugger;
            this.$toast.add({severity:'info', summary:this.translated('confirmation'), detail:this.translated('savedChanges'), life: 3000});
        },

        saveChild() {
            this.$refs.personModal.Save();
        },
        async childSaved(savedperson) {
            debugger;
            this.$toast.add({severity:'info', summary:this.translated('confirmation'), detail:this.translated('savedChanges'), life: 3000});
            this.displayModalUser=false;
            this.getChildPersons();
        },
        async copyPerson(){        
            debugger;    
            const myData = await this.Load(this.childUserId);
            this.$refs.personModal.SetPerson(myData);
        },
        async Load(){
            this.isLoading = true;

            const http = createHttp(true);            
            const result = await http.get(process.env.VUE_APP_API_FOLDER + "/getPerson");
            this.isLoading = false;

            return result.status==200 ? result.data : null;
        },        
    }    
}
</script>


<style scoped>


.labeldiv { padding-bottom:0px}
.elementGroup { margin-bottom: 10px}
.submitsave{ position: relative; float: right;}
.submitback{ position: relative; float: left;}
.profile-view-left, .profile-view-right {padding-top: 40px;}
.modal-buttons{text-align: center;display: flex;justify-content: center;}
ul.p-dropdown-items li:last-child {background: #b79595 !important;color: white !important;font-weight: bold;}

.personEditIcon { width: 20px; }
.personJmbgLabel, .personEmailLabel, .personEditIcon { position: relative; float: left; }
.personJmbgLabel, .personEmailLabel { margin-right: 5px; }
.personControls button { position:relative; float:right; width:25px; height:25px;}
.personEmail {position:relative; float:left;}
button.editPersonButton {margin-right: 10px;}

.card.col-12.subtitleHeader {background: rgba(0, 0, 0, 0.12);margin-bottom: 0px;font-size: 1.2rem;}
.grid.headerTableSubPerson {background: #ced4da;margin-bottom: 10px;}

.grid.elementPersonGroup {border-bottom: solid 1px lightgrey;}

.subPersonHeader {position: relative;float: left;}

button.p-button.p-component.addNewPerson {position: relative;float: right;}
.subPersonHeaderPlace {position: relative;float: left;height: 100%;display: grid;align-items: center;justify-items: center;}

.titleSubPersonPlaceholder {position: relative;height: 100%;}

.p-fluid.grid.elementGroup.elementPersonGroup:hover {background: #efefef;}

button.btnCopy {position: relative;float: left;}
button.btnSave {margin-right: 20px;}

@media screen and (min-width: 575px)
{
    .hideOnDesktop  {display: none;}
}

@media screen and (max-width: 575px)
{
    .hideOnMobile  {display: none;}
}

</style>